module.exports = __webpack_public_path__ + "media/images/question_mark-6f337942.svg";